(function($) {
	'use strict';

	/**
	 * Calculate CIS framework averages
	 * @returns {Promise} Promise that resolves with implementation group averages and overall maturity
	 */
	function calculateCISAverages() {
		return new Promise((resolve, reject) => {
			try {
				// Hide the mark complete button and show spinner at the start of calculations
				$('.mark-complete-modal-buttons').hide();
				$('#markCompleteButton').hide();
				$('.spinner-border').show();

				let items = WebAssessmentCharts.processedItems;
				console.log("Original items:", items);

				// Determine the CIS version. The slug of the project being scored comes
				// first: currentCisVersion is a page-wide cache left by whichever CIS
				// project was scored last, so preferring it scored a second project in the
				// same page session against the wrong standard.
				let cisStandardId = null;
				let detectionSource = 'unknown';
				const slugMatch = (typeof WebAssessmentCharts !== 'undefined' && WebAssessmentCharts.frameworkSlug)
					? String(WebAssessmentCharts.frameworkSlug).toLowerCase().match(/^cis-(\d+)-(\d+)/)
					: null;

				if (slugMatch) {
					cisStandardId = `CIS-${slugMatch[1]}-${slugMatch[2]}`; // cis-8-0 -> CIS-8-0
					detectionSource = 'WebAssessmentCharts.frameworkSlug';
				} else if (typeof WebAssessmentCharts !== 'undefined' && WebAssessmentCharts.currentCisVersion) {
					cisStandardId = WebAssessmentCharts.currentCisVersion; // e.g., 'CIS-7-1', 'CIS-8-0', 'CIS-8-1'
					detectionSource = 'WebAssessmentCharts.currentCisVersion';
				}
				console.log(`[CIS Version Detection] ${cisStandardId || 'not found'} (source: ${detectionSource})`);
				
				// If still not found, try to determine from items
				if (!cisStandardId && items.length > 0) {
					console.log(`[CIS Version Detection] Checking items for standardid/standardversion...`);
					const itemWithStandard = items.find(item => item.standardid?.S || item.standardversion?.S);
					if (itemWithStandard) {
						cisStandardId = itemWithStandard.standardid?.S || itemWithStandard.standardversion?.S;
						detectionSource = 'items (standardid/standardversion)';
						console.log(`[CIS Version Detection] Found in items: ${cisStandardId} (from ${itemWithStandard.standardid?.S ? 'standardid' : 'standardversion'})`);
					} else {
						console.log(`[CIS Version Detection] No standardid or standardversion found in items`);
					}
				} else if (!cisStandardId) {
					console.log(`[CIS Version Detection] No items available to check`);
				}
				
				// No default: a guessed version scores the answers against the wrong
				// standard (CIS 8.0 and 8.1 differ in 102 of 153 IG tags), and a wrong score
				// would be saved on finalize. Fail so no score is posted.
				if (!cisStandardId) {
					$('.mark-complete-modal-buttons').show();
					$('#markCompleteButton').show();
					$('.spinner-border').hide();
					reject(new Error('calculateCISAverages: could not determine the CIS version'));
					return;
				}
				
				console.log(`[CIS Version Detection] Final CIS version: ${cisStandardId} (source: ${detectionSource})`);
				
				// Determine assessment year dynamically
				let assessmentYear = '2025'; // Default
				let yearSource = 'default';
				if (typeof WebAssessmentCharts !== 'undefined' && WebAssessmentCharts.assessmentYear) {
					assessmentYear = WebAssessmentCharts.assessmentYear;
					yearSource = 'WebAssessmentCharts.assessmentYear';
					console.log(`[Year Detection] Found in WebAssessmentCharts.assessmentYear: ${assessmentYear}`);
				} else if (items.length > 0) {
					const itemWithYear = items.find(item => item.frameworkversion?.S);
					if (itemWithYear) {
						assessmentYear = itemWithYear.frameworkversion.S;
						yearSource = 'items (frameworkversion)';
						console.log(`[Year Detection] Found in items frameworkversion: ${assessmentYear}`);
					} else {
						console.log(`[Year Detection] No frameworkversion found in items, using default: ${assessmentYear}`);
					}
				} else {
					console.log(`[Year Detection] No items available, using default: ${assessmentYear}`);
				}
				
				console.log(`[Framework Averages] Fetching CIS standards - Version: ${cisStandardId} (${detectionSource}), Year: ${assessmentYear} (${yearSource})`);

				// Check if we already have the correct CIS standard data cached
				let standardsPromise;
				if (typeof WebAssessmentCharts !== 'undefined' && 
					WebAssessmentCharts.cisStandardData && 
					WebAssessmentCharts.currentCisVersion === cisStandardId) {
					console.log(`[Cache Check] Reusing cached CIS standard data for ${cisStandardId} (cached version: ${WebAssessmentCharts.currentCisVersion})`);
					standardsPromise = Promise.resolve(WebAssessmentCharts.cisStandardData);
				} else {
					if (typeof WebAssessmentCharts !== 'undefined') {
						if (!WebAssessmentCharts.cisStandardData) {
							console.log(`[Cache Check] No cached data available, fetching...`);
						} else if (WebAssessmentCharts.currentCisVersion !== cisStandardId) {
							console.log(`[Cache Check] Cached version mismatch - cached: ${WebAssessmentCharts.currentCisVersion}, needed: ${cisStandardId}, fetching...`);
						}
					} else {
						console.log(`[Cache Check] WebAssessmentCharts not available, fetching...`);
					}
					// Fetch CIS standards data
					standardsPromise = jQuery.ajax({
						url: '/wp-admin/admin-ajax.php',
						type: 'POST',
						dataType: 'json',
						data: {
							action: 'api_action',
							year: assessmentYear,
							apis: ['CS'],
							CSLstandardID: cisStandardId
						}
					}).then(response => {
						// Cache the response for future use
						if (typeof WebAssessmentCharts !== 'undefined') {
							WebAssessmentCharts.cisStandardData = response;
							WebAssessmentCharts.currentCisVersion = cisStandardId;
						}
						return response;
					});
				}

				standardsPromise.then(response => {
					console.log('CIS Standards response:', response);

					if (!response.CS || !response.CS.Items) {
						console.error('Invalid CIS standards response structure:', response);
						throw new Error('Invalid CIS standards response structure');
					}

					// Create a map of control IDs to their priorities from standards
					const controlPriorities = {};
					response.CS.Items.forEach(control => {
						if (control.controlid?.S && control.controlpriority?.S) {
							controlPriorities[control.controlid.S] = control.controlpriority.S;
						}
					});

					console.log('Control priorities map:', controlPriorities);

					// Step 1: Get the most recent safeguards with priorities
					const mostRecentSafeguards = items.reduce((acc, item) => {
						const safeguardId = item.safeguardid.S;
						const timestamp = parseInt(item.timestamp, 10);

						if (!acc[safeguardId] || acc[safeguardId].timestamp < timestamp) {
							// Add the control priority from our standards map
							item.controlpriority = { S: controlPriorities[safeguardId] || '' };
							acc[safeguardId] = item;
						}

						return acc;
					}, {});

				console.log("Most recent safeguards with priorities: ", mostRecentSafeguards);

				// Check if this CIS version uses category averages (7.0 and below) or implementation groups (7.1 and above)
				// Parse the version: CIS-7-0, CIS-7-1, CIS-8-0, CIS-8-1, etc.
				const versionParts = cisStandardId.match(/CIS-(\d+)-(\d+)/);
				const useCategoryAverages = versionParts && (
					parseInt(versionParts[1], 10) < 7 || // CIS 6.x and below
					(parseInt(versionParts[1], 10) === 7 && parseInt(versionParts[2], 10) === 0) // CIS 7.0
				);
				
				console.log(`[CIS Version Check] Version: ${cisStandardId}, Use Category Averages: ${useCategoryAverages} (CIS 7.0 and below use category averages, CIS 7.1+ use implementation groups)`);

				// If CIS 7.0 or below, use category averages instead of implementation groups
				if (useCategoryAverages) {
					// Get calculateCategoryAverages function from available sources
					let calculateCategoryAveragesFn = null;
					if (typeof calculateCategoryAverages !== 'undefined') {
						calculateCategoryAveragesFn = calculateCategoryAverages;
					} else if (typeof window !== 'undefined' && typeof window.calculateCategoryAverages !== 'undefined') {
						calculateCategoryAveragesFn = window.calculateCategoryAverages;
					} else if (typeof WebAssessmentCharts !== 'undefined' && WebAssessmentCharts.calculateCategoryAverages) {
						calculateCategoryAveragesFn = WebAssessmentCharts.calculateCategoryAverages;
					}
					
					if (!calculateCategoryAveragesFn) {
						console.error('[CIS Category Averages] calculateCategoryAverages function not found');
						throw new Error('calculateCategoryAverages function not available');
					}
					
					console.log('[CIS Category Averages] Using category averages for CIS 7.0 and below');
					const categoryAverages = calculateCategoryAveragesFn(Object.values(mostRecentSafeguards), response);
					
					// Calculate overall maturity as average of all category averages
					const categoryValues = Object.values(categoryAverages).filter(v => v !== null);
					const overallMaturity = categoryValues.length > 0 
						? (categoryValues.reduce((sum, val) => sum + val, 0) / categoryValues.length) * 5 
						: 0;
					
					// Set appropriate maturity variables based on version
					if (typeof WebAssessmentCharts !== 'undefined') {
						if (cisStandardId === 'CIS-7-0') {
							WebAssessmentCharts.overallCIS70maturity = overallMaturity;
						} else {
							WebAssessmentCharts.overallCIS7maturity = overallMaturity;
						}
					}
					
					console.log(`[CIS Category Averages] Calculated overall maturity score: ${overallMaturity.toFixed(2)}`);
					
					// Create chart after data is ready
					if ($('body').hasClass('single-projects')) {
						WebAssessmentCharts.createChartFromTable('cis', 'cis-chart', charts, true);
					}
					
					// Show the mark complete button and hide spinner after calculations are done
					$('.mark-complete-modal-buttons').show();
					$('#markCompleteButton').show();
					$('.spinner-border').hide();
					
					resolve({
						categoryAverages: categoryAverages,
						overallMaturity: overallMaturity
					});
					return; // Exit early, don't continue with implementation group calculation
				}

				// Helper function to parse priority string and return array of IG numbers
				// e.g., '2,3' returns ['2', '3'], '1,2,3' returns ['1', '2', '3'], '3' returns ['3']
				function parsePriority(priorityString) {
					if (!priorityString) return [];
					return priorityString.split(',').map(p => p.trim()).filter(p => ['1', '2', '3'].includes(p));
				}

				// Step 2: Calculate implementation group scores (for CIS 7.1 and above)
				const igScores = {
					'1': { total: 0, count: 0, controls: new Set(), applicableCount: 0, applicableControls: new Set(), unansweredCount: 0, naCount: 0 },
					'2': { total: 0, count: 0, controls: new Set(), applicableCount: 0, applicableControls: new Set(), unansweredCount: 0, naCount: 0 },
					'3': { total: 0, count: 0, controls: new Set(), applicableCount: 0, applicableControls: new Set(), unansweredCount: 0, naCount: 0 }
				};

				// First pass: count total applicable safeguards from standards
				// Use parsePriority to handle all priority combinations correctly
				response.CS.Items.forEach(control => {
					if (!control.controlpriority || !control.controlpriority.S) return;
					
					const controlPriority = control.controlpriority.S;
					const igNumbers = parsePriority(controlPriority);
					
					// Add to all relevant IGs
					igNumbers.forEach(ig => {
						igScores[ig].applicableCount++;
					});
				});

				console.log('DEBUG - Total Applicable Counts per IG from Standards:', {
					'1': igScores['1'].applicableCount,
					'2': igScores['2'].applicableCount,
					'3': igScores['3'].applicableCount
				});

				// Second pass: Calculate scores from actual implementation data
				// Use control ID from standards (not safeguard ID) to match calculateImplementationGroupScores logic
				Object.values(mostRecentSafeguards).forEach(item => {
					if (!item.controlpriority || !item.controlpriority.S) {
						return;
					}

					const controlPriority = item.controlpriority.S;
					const maturityScore = item.maturityscore; // Can be null for policy status 1
					const safeguardId = item.safeguardid.S;
					const policystatus = parseInt(item.policystatus?.N || '0', 10);
					const isNotApplicable = policystatus === 1;

					// For pure CIS assessments, safeguardId should be the same as controlId
					// But we'll use the control ID from standards to be consistent
					// Find the control ID from standards that matches this safeguard ID
					let controlId = safeguardId; // Default to safeguardId (for pure CIS assessments)
					
					// Try to find matching control ID in standards
					const matchingControl = response.CS.Items.find(c => 
						c.controlid?.S === safeguardId || 
						c.controlid?.S === safeguardId.replace(/^CIS-\d+-\d+-/, '') || // Handle prefixed IDs
						c.controlid?.S?.endsWith('-' + safeguardId) ||
						c.controlid?.S?.endsWith('_' + safeguardId)
					);
					
					if (matchingControl && matchingControl.controlid?.S) {
						controlId = matchingControl.controlid.S;
					}

					// Determine which implementation group(s) this control belongs to based on priority
					// Priority can be comma-separated (e.g., '2,3' means it belongs to both IG2 and IG3)
					// Use control ID as the key to prevent duplicates (matching calculateImplementationGroupScores)
					const igNumbers = parsePriority(controlPriority);
					
					igNumbers.forEach(ig => {
						if (!igScores[ig].controls.has(controlId)) {
							igScores[ig].controls.add(controlId);
							
							// Count as applicable if not marked as Not Applicable
							if (!isNotApplicable) {
								igScores[ig].applicableControls.add(controlId);
								
								// Only add to total if it has a maturity score
								if (maturityScore !== null) {
									igScores[ig].total += maturityScore;
									igScores[ig].count++;
								} else {
									// Count unanswered questions
									igScores[ig].unansweredCount++;
								}
							} else {
								// Count Not Applicable items
								igScores[ig].naCount++;
							}
						}
					});
				});

				// Count unanswered questions from standards that weren't in the items
				// Use Map structure to match calculateImplementationGroupScores logic
				const allSafeguards = new Map();
				response.CS.Items.forEach(control => {
					if (control.controlid && control.controlid.S && control.controlpriority && control.controlpriority.S) {
						const controlId = control.controlid.S;
						allSafeguards.set(controlId, {
							safeguardid: { S: controlId },
							controlpriority: control.controlpriority
						});
					}
				});

				// Iterate over all safeguards from standards and check if they're in items
				// Use control ID as the key (matching calculateImplementationGroupScores)
				allSafeguards.forEach((control, controlId) => {
					if (!igScores['1'].controls.has(controlId) && 
						!igScores['2'].controls.has(controlId) && 
						!igScores['3'].controls.has(controlId)) {
						
						const controlPriority = control.controlpriority.S;
						const igNumbers = parsePriority(controlPriority);
						
						// Add to unanswered count for all relevant IGs
						igNumbers.forEach(ig => {
							igScores[ig].unansweredCount++;
						});
					}
				});

				console.log('DEBUG - Implementation Group Totals:', {
					'1': { 
						total: igScores['1'].total, 
						count: igScores['1'].count, 
						applicableCount: igScores['1'].applicableCount,
						applicableControlsCount: igScores['1'].applicableControls.size,
						unansweredCount: igScores['1'].unansweredCount,
						naCount: igScores['1'].naCount,
						controlsSetSize: igScores['1'].controls.size
					},
					'2': { 
						total: igScores['2'].total, 
						count: igScores['2'].count, 
						applicableCount: igScores['2'].applicableCount,
						applicableControlsCount: igScores['2'].applicableControls.size,
						unansweredCount: igScores['2'].unansweredCount,
						naCount: igScores['2'].naCount,
						controlsSetSize: igScores['2'].controls.size
					},
					'3': { 
						total: igScores['3'].total, 
						count: igScores['3'].count, 
						applicableCount: igScores['3'].applicableCount,
						applicableControlsCount: igScores['3'].applicableControls.size,
						unansweredCount: igScores['3'].unansweredCount,
						naCount: igScores['3'].naCount,
						controlsSetSize: igScores['3'].controls.size
					}
				});

				// Calculate averages for each implementation group
				// The denominator should be the total possible controls from standards (minus NA items)
				// Unanswered controls count as 0 in the numerator
				const igAverages = {};
				Object.keys(igScores).forEach(ig => {
					const { total, applicableControls, applicableCount, unansweredCount, naCount } = igScores[ig];
					
					// Denominator is the total possible controls from standards minus NA items
					// This includes both answered and unanswered controls
					const totalPossibleControls = applicableCount > 0 ? (applicableCount - naCount) : applicableControls.size;
					
					// Calculate score - using total possible controls as denominator
					const score = totalPossibleControls > 0 ? (total / totalPossibleControls) * 5 : 0;
					console.log(`Calculating score for IG${ig}:`, {
						total,
						totalPossibleControls,
						applicableCountFromStandards: applicableCount,
						naCount,
						applicableControlsObserved: applicableControls.size,
						unansweredCount,
						calculation: `(${total} / ${totalPossibleControls}) * 5 = ${score}`,
						explanation: `total is sum of ${applicableControls.size} answered controls (0-1 scale). ${unansweredCount} unanswered controls count as 0. Denominator is ${totalPossibleControls} total possible controls (minus ${naCount} NA).`
					});
					igAverages[ig] = score;
				});

				console.log('DEBUG - Final Scores:', igAverages);
				console.log("Implementation Group Averages:", igAverages);

				// Calculate the overall maturity score as the average of the three implementation group scores
				const overallMaturity = (igAverages['1'] + igAverages['2'] + igAverages['3']) / 3;
				WebAssessmentCharts.overallCIS70maturity = overallMaturity;
				WebAssessmentCharts.overallCIS71maturity = overallMaturity;
				WebAssessmentCharts.overallCIS80maturity = overallMaturity;
				WebAssessmentCharts.overallCIS81maturity = overallMaturity;
				console.log(`Calculated overall maturity score (average of IG scores): ${overallMaturity.toFixed(2)}`);
				
				// Create chart after data is ready
				if ($('body').hasClass('single-projects')) {
					WebAssessmentCharts.createChartFromTable('cis', 'cis-chart', charts, true);
				}
				
				// Show the mark complete button and hide spinner after calculations are done
				$('.mark-complete-modal-buttons').show();
				$('#markCompleteButton').show();
				$('.spinner-border').hide();
				
				resolve({
					implementationGroupAverages: igAverages,
					overallMaturity: overallMaturity
				});
				})
				.catch(error => {
					console.error('Error fetching CIS standards:', error);
					// Show the button and hide spinner even in case of error, so the user can still proceed if needed
					$('.mark-complete-modal-buttons').show();
					$('#markCompleteButton').show();
					$('.spinner-border').hide();
					reject(error);
				});
			} catch (error) {
				console.error('Error in calculateCISAverages:', error);
				reject(error);
			}
		});
	}

	/**
	 * Calculate NIST2 framework averages
	 * @returns {Promise} Promise that resolves with category averages and overall maturity
	 */
	function calculateNIST2Averages() {
		return new Promise((resolve, reject) => {
			try {
				$('.nist2-container').hide();
				let items = WebAssessmentCharts.processedItems;
				console.log("Original items:", items);

				// Determine NIST version from the framework slug and the year from the
				// slug or items. No default version: scoring 1.x answers against 2.0 finds
				// no matching IDs and saves a near-zero score.
				let nistStandardId = null;
				let assessmentYear = '2024'; // Default
				
				if (typeof WebAssessmentCharts !== 'undefined' && WebAssessmentCharts.frameworkSlug) {
					const slug = WebAssessmentCharts.frameworkSlug.toLowerCase();
					if (slug.includes('nist-csf-1-0') || slug.includes('nist-csf-1.0')) {
						nistStandardId = 'NIST-CSF-1-0';
					} else if (slug.includes('nist-csf-1-1') || slug.includes('nist-csf-1.1')) {
						nistStandardId = 'NIST-CSF-1-1';
					} else if (slug.includes('nist-csf-2-0') || slug.includes('nist-csf-2.0')) {
						nistStandardId = 'NIST-CSF-2-0';
					}
				}
				
				if (!nistStandardId) {
					$('.nist2-container').show();
					reject(new Error('calculateNIST2Averages: could not determine the NIST CSF version'));
					return;
				}
				
				if (typeof WebAssessmentCharts !== 'undefined' && WebAssessmentCharts.assessmentYear) {
					assessmentYear = WebAssessmentCharts.assessmentYear;
				} else if (items.length > 0) {
					const itemWithYear = items.find(item => item.frameworkversion?.S);
					if (itemWithYear) {
						assessmentYear = itemWithYear.frameworkversion.S;
					}
				}

				console.log(`[NIST Calculation] Using standard: ${nistStandardId}, year: ${assessmentYear}`);

				// Fetch NIST standard data to get potential counts and merge unanswered items
				const nistDataPromise = jQuery.ajax({
					url: '/wp-admin/admin-ajax.php',
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'api_action',
						year: assessmentYear,
						apis: ['CS'],
						CSLstandardID: nistStandardId
					}
				}).then(response => {
					if (response && response.CS && response.CS.Items) {
						return response;
					}
					return null;
				}).catch(error => {
					console.warn('Error fetching NIST standard data, proceeding without it:', error);
					return null;
				});

				nistDataPromise.then(nistStandardData => {
					// Step 1: Get the most recent safeguards
					const mostRecentSafeguards = items.reduce((acc, item) => {
						const safeguardId = item.safeguardid.S;
						const timestamp = parseInt(item.timestamp, 10);

						if (!acc[safeguardId] || acc[safeguardId].timestamp < timestamp) {
							acc[safeguardId] = item;
						}

						return acc;
					}, {});

					console.log("Most recent safeguards: ", mostRecentSafeguards);

					// Step 2: Merge in unanswered items from standards (same as individual assessment files)
					const allSafeguards = new Map();
					if (nistStandardData && nistStandardData.CS && nistStandardData.CS.Items) {
						nistStandardData.CS.Items.forEach(control => {
							if (control.controlid && control.controlid.S) {
								allSafeguards.set(control.controlid.S, {
									safeguardid: { S: control.controlid.S },
									policystatus: { N: "0" }, // Default to "Not Answered"
									maturityscore: 0 // Default score for unanswered items
								});
							}
						});
					}

					// Merge in actual answers
					Object.values(mostRecentSafeguards).forEach(item => {
						allSafeguards.set(item.safeguardid.S, item);
					});

					const mergedItems = Array.from(allSafeguards.values());
					console.log('Merged items (including unanswered):', mergedItems);

					// Step 3: Use the same calculation method as individual assessment files
					// Check if calculateNISTCategoryAverages is available (from web-assessment-charts-nist files)
					let averages;
					if (typeof WebAssessmentCharts.calculateNISTCategoryAverages === 'function') {
						console.log('[NIST Calculation] Using calculateNISTCategoryAverages from web-assessment-charts-nist files');
						averages = WebAssessmentCharts.calculateNISTCategoryAverages(mergedItems, nistStandardData);
					} else {
						// Fallback: Use the same calculation logic inline (matching web-assessment-charts-nist files)
						console.log('[NIST Calculation] calculateNISTCategoryAverages not available, using inline calculation');
						
						const categoryScores = {};
						const categoryPotentialCounts = {};
						
						// First gather potential counts from NIST standard data if available
						if (nistStandardData && nistStandardData.CS && nistStandardData.CS.Items) {
							nistStandardData.CS.Items.forEach(control => {
								if (control.controlid && control.controlid.S) {
									const safeguardId = control.controlid.S;
									const parts = safeguardId.split('-');
									const category = parts[0];
									
									if (!categoryPotentialCounts[category]) {
										categoryPotentialCounts[category] = 0;
									}
									categoryPotentialCounts[category]++;
								}
							});
						}
						
						// Initialize category scores structure with potential counts
						Object.keys(categoryPotentialCounts).forEach(category => {
							categoryScores[category] = { 
								total: 0, 
								count: 0, 
								nullCount: 0, 
								totalItems: 0,
								applicableItems: 0,
								potentialCount: categoryPotentialCounts[category]
							};
						});

						// Process actual scores from items
						mergedItems.forEach(item => {
							const safeguardId = item.safeguardid.S;
							const parts = safeguardId.split('-');
							const category = parts[0];
							const maturityScore = item.maturityscore;
							const policystatus = parseInt(item.policystatus?.N || '0', 10);

							if (!categoryScores[category]) {
								categoryScores[category] = { 
									total: 0, 
									count: 0, 
									nullCount: 0, 
									totalItems: 0,
									applicableItems: 0,
									potentialCount: categoryPotentialCounts[category] || 0
								};
							}

							categoryScores[category].totalItems++;

							// Check if item is Not Applicable (policy status 1)
							if (policystatus === 1) {
								categoryScores[category].nullCount++;
							} else {
								// Item is applicable (whether filled out or not)
								categoryScores[category].applicableItems++;
								
								// Only add to total if it has a maturity score
								if (maturityScore !== null) {
									categoryScores[category].total += maturityScore;
									categoryScores[category].count++;
								}
							}
						});

						// Calculate averages using applicableItems as denominator (same as individual assessment)
						const averages = {};
						Object.keys(categoryScores).forEach(category => {
							const { total, count, nullCount, totalItems, applicableItems, potentialCount } = categoryScores[category];
							
							// If all items in category are marked as "Not Applicable", set average to null
							if (nullCount === totalItems && totalItems > 0) {
								averages[category] = null;
							} else {
								// Use applicableItems as denominator (total items minus Not Applicable items)
								const denominator = applicableItems > 0 ? applicableItems : (potentialCount || count);
								averages[category] = denominator > 0 ? total / denominator : 0;
								console.log(`Category ${category}: total=${total}, applicableItems=${applicableItems}, potentialCount=${potentialCount}, actual count=${count}, nullCount=${nullCount}, denominator=${denominator}, average=${averages[category]}`);
							}
						});

						console.log("NIST Category averages: ", averages);
					}

					// Calculate overall maturity from core function averages (same as individual assessment)
					// This must be done after averages are calculated, regardless of which path was used
					console.log('[NIST Calculation] Calculating core function averages from category averages...');
					console.log('[NIST Calculation] Available calculateCoreFunctionAverages?', typeof calculateCoreFunctionAverages);
					console.log('[NIST Calculation] Available window.calculateCoreFunctionAverages?', typeof window.calculateCoreFunctionAverages);
					
					// Try multiple sources for calculateCoreFunctionAverages
					let calculateCoreFunctionAveragesFn = null;
					if (typeof calculateCoreFunctionAverages === 'function') {
						calculateCoreFunctionAveragesFn = calculateCoreFunctionAverages;
					} else if (typeof window !== 'undefined' && typeof window.calculateCoreFunctionAverages === 'function') {
						calculateCoreFunctionAveragesFn = window.calculateCoreFunctionAverages;
					}
					
					if (!calculateCoreFunctionAveragesFn) {
						console.error('[NIST Calculation] calculateCoreFunctionAverages function not found!');
						// Fallback: calculate overall from category averages directly (less accurate)
						const categoryValues = Object.values(averages).filter(v => v !== null && v !== undefined);
						const overallMaturity = categoryValues.length > 0 
							? (categoryValues.reduce((sum, val) => sum + val, 0) / categoryValues.length) * 5 
							: 0;
						
						WebAssessmentCharts.overallNIST1maturity = overallMaturity;
						WebAssessmentCharts.overallNIST11maturity = overallMaturity;
						WebAssessmentCharts.overallNIST2maturity = overallMaturity;
						
						console.log(`[NIST Calculation] Calculated overall maturity score (fallback from categories): ${overallMaturity.toFixed(2)}`);
						$('.audit-overall-value').text(overallMaturity.toFixed(2));
						
						if (jQuery('body').hasClass('single-projects')) {
							WebAssessmentCharts.createChartFromTable('nist2', 'nist2-chart', charts, true);
						}
						$('.nist2-container').show();
						
						resolve({
							categoryAverages: averages,
							overallMaturity: overallMaturity
						});
						return;
					}
					
					// Calculate core function averages (expects 0-1 scale inputs, returns 0-5 scale)
					const coreFunctionAverages = calculateCoreFunctionAveragesFn(averages);
					console.log('[NIST Calculation] Core function averages:', coreFunctionAverages);
					
					// Calculate overall maturity from core function averages (same as individual assessment)
					const coreFunctionValues = Object.values(coreFunctionAverages);
					let overallMaturity = 0;
					if (coreFunctionValues.length > 0) {
						overallMaturity = coreFunctionValues.reduce((sum, value) => sum + value, 0) / coreFunctionValues.length;
					}

					WebAssessmentCharts.overallNIST1maturity = overallMaturity;
					WebAssessmentCharts.overallNIST11maturity = overallMaturity;
					WebAssessmentCharts.overallNIST2maturity = overallMaturity;

					console.log(`[NIST Calculation] Calculated overall maturity score (from core functions): ${overallMaturity.toFixed(2)}`);
					$('.audit-overall-value').text(overallMaturity.toFixed(2));
					
					// Create chart after data is ready, but only if this is a single project post
					if (jQuery('body').hasClass('single-projects')) {
						WebAssessmentCharts.createChartFromTable('nist2', 'nist2-chart', charts, true);
					}
					$('.nist2-container').show();

					resolve({
						categoryAverages: averages,
						overallMaturity: overallMaturity
					});
				}).catch(error => {
					console.error('Error in calculateNIST2Averages:', error);
					reject(error);
				});
			} catch (error) {
				console.error('Error in calculateNIST2Averages:', error);
				reject(error);
			}
		});
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { calculateCISAverages, calculateNIST2Averages };
	} else if (typeof window !== 'undefined') {
		window.calculateCISAverages = calculateCISAverages;
		window.calculateNIST2Averages = calculateNIST2Averages;
		
		// Also export to WebAssessmentCharts namespace for dashboard compatibility
		if (!window.WebAssessmentCharts) {
			window.WebAssessmentCharts = {};
		}
		window.WebAssessmentCharts.calculateCISAverages = calculateCISAverages;
		window.WebAssessmentCharts.calculateNIST2Averages = calculateNIST2Averages;
	}

})(jQuery);
